import { Pipe, PipeTransform, inject } from "@angular/core"
import { ContextService } from "../services"
import { Location } from "../models"

@Pipe({
    name: "locationNames",
    pure: false,
    standalone: true,
})
export class LocationNamesPipe implements PipeTransform {
    private _cs = inject(ContextService)

    constructor() {
        this._cs.InitLocations()
    }

    transform(ids: string | string[] | null | undefined): string {
        if (!ids) return ""
        const list = Array.isArray(ids) ? ids : [ids]
        const locations: Location[] = this._cs.getLocationsSubject()?.value ?? []
        return list.map(id => locations.find(l => l.masterId === id)?.names?.["hr"] || id).join(", ")
    }
}
